import request from '@/lib/request';

const api = {};

// 绑定QQ或微信账号
api.bindLoginAccount = reqData => request({
  url: 'v3/login_account/bind',
  method: 'post',
  data: reqData,
});

// 解绑QQ或微信账号
api.unbindLoginAccount = reqData => request({
  url: 'v3/user/loginaccount/unbind',
  method: 'post',
  data: reqData,
});

// 修改昵称
api.modifyNickname = reqData => request({
  url: 'v3/cp/user/modify/nickname',
  method: 'post',
  data: reqData,
});

// 接受电商协议
api.acceptECProtocol = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/user/protocol/accept',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 接受邀请子账户规则
api.acceptInviteProtocol = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/user/invite_agreement/accept',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 解绑saas
api.unbindSaas = (reqData, autoErrorTips = true) => request({
  url: 'v3/cp/saas/unbind',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

// 绑定手机号
api.bindPhone = (reqData, autoErrorTips = true) => request({
  url: 'v3/user/phone/bind',
  method: 'post',
  data: reqData,
  autoErrorTips,
});

export default api;
